import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { X, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";

const StickySignupBar = () => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Check if user already dismissed the bar in this session
    const dismissed = sessionStorage.getItem("stickyBarDismissed");
    if (dismissed) {
      setIsDismissed(true);
      return;
    }

    const handleScroll = () => {
      // Show bar after scrolling past 500px (roughly past the Hero section)
      const shouldShow = window.scrollY > 500;
      setIsVisible(shouldShow);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleDismiss = () => {
    setIsDismissed(true);
    sessionStorage.setItem("stickyBarDismissed", "true");
  };

  if (isDismissed || !isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-primary/95 backdrop-blur-sm border-t border-primary-foreground/10 shadow-lg animate-in slide-in-from-bottom duration-300">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <Sparkles className="w-5 h-5 text-primary-foreground hidden sm:block" />
            <p className="text-primary-foreground text-sm sm:text-base font-medium">
              Prêt à simplifier vos réservations ?
              <span className="hidden sm:inline"> 1 mois gratuit, sans engagement</span>
            </p>
          </div>
          
          <div className="flex items-center gap-2">
            <Button 
              size="sm"
              variant="secondary"
              className="bg-primary-foreground text-primary hover:bg-primary-foreground/90 font-semibold whitespace-nowrap"
              onClick={() => navigate("/signup")}
            >
              <span className="sm:hidden">Essayer</span>
              <span className="hidden sm:inline">Créer un compte gratuit</span>
            </Button>
            <button
              onClick={handleDismiss}
              className="p-1.5 rounded-full hover:bg-primary-foreground/10 transition-colors"
              aria-label="Fermer"
            >
              <X className="w-4 h-4 text-primary-foreground/70" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickySignupBar;
